import Menu from './Menu';
import MenuItem from './MenuItem';
import MenuSeparator from './MenuSeparator';

// export types
export type { MenuProps } from './Menu';
export type { MenuItemProps } from './MenuItem';
export type { MenuSeparatorProps } from './MenuSeparator';

// export components
export { Menu, MenuItem, MenuSeparator };
export default Menu;
